import BasicInitializationService from "../../services/initialization/basicInitializationService";
import makeWidgetFor from "../../viewModels/makeWidgetFor";
import TradingPlacesViewModel from "../../viewModels/tradingPlaces/tradingPlacesViewModel";
import { registerWidget } from "../widget";

const TradingPlacesWidgetIdentifier = "edaz-trading-places";

registerWidget({
  component: makeWidgetFor(TradingPlacesWidgetIdentifier, [TradingPlacesViewModel], BasicInitializationService),
  configuration: {
    tagname: TradingPlacesWidgetIdentifier,
  },
});
